// access ページ固有スクリプト
export default class accessPage {
  constructor() {
    this.facilitySlider();
  }

  facilitySlider() {
    const SPEED = 0.5; // px / frame
    const track = document.querySelector('.js-facilitySlider-track');
    if (!track) return;
    const originals = Array.from(track.children);
    if (!originals.length) return;
  
    let x = 0;
    let setWidth = 0;
    let rafId = null;
  
    const clearClones = () => {
      Array.from(track.querySelectorAll('.is-clone')).forEach((clone) => clone.remove());
    };
  
    const appendSet = () => {
      originals.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.classList.add('is-clone');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    };
  
    const measure = () => {
      clearClones();
      // 1 セット分を複製し、複製先頭の offsetLeft で 1 セット幅（＝ループ周期）を計測
      appendSet();
      setWidth = track.children[originals.length].offsetLeft;
      // ビューポート＋1 セットを覆うまでセットを足す（端で空白が出ないように）
      const need = window.innerWidth + setWidth + 100;
      let guard = 0;
      while (track.scrollWidth < need && guard < 30) {
        appendSet();
        guard++;
      }
      x = 0;
    };
  
    const frame = () => {
      if (setWidth > 0) {
        x -= SPEED;
        if (x <= -setWidth) x += setWidth;
        track.style.transform = `translate3d(${x}px, 0, 0)`;
      }
      rafId = window.requestAnimationFrame(frame);
    };
  
    let resizeT = null;
    window.addEventListener('resize', () => {
      clearTimeout(resizeT);
      resizeT = setTimeout(measure, 200);
    });
  
    // 画像ロードで寸法が変わる場合に備えて再計測
    track.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', measure, { once: true });
    });
  
    measure();
    if (rafId === null) frame();
  }
}


